import React from 'react';
import { Button, Select, Space } from 'antd';
import { SolutionOutlined, UserAddOutlined } from '@ant-design/icons';
import { toSearchText } from 'utils/text';

const CustomerPickerDesktop = ({ viewModel }) => {
  const {
    value,
    onChange,
    placeholder,
    selectProps,
    options,
    loading,
    setShowAddCustomer,
    setShowCustomerInfo,
  } = viewModel;

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <div style={{ flexGrow: 1 }}>
        <Select
          {...selectProps}
          value={value}
          showSearch
          placeholder={placeholder}
          onChange={onChange}
          options={options}
          loading={loading}
          optionFilterProp='label'
          filterOption={(input, option) => {
            const inputSearchText = toSearchText(input || '');
            const optionSearchText = option?.searchText || toSearchText(option?.label || '');

            return optionSearchText.includes(inputSearchText);
          }}
          notFoundContent={(
            <div>
              Không tìm thấy khách hàng
              <br />
              Bạn có thể tạo mới khách hàng
            </div>
          )}
        />
      </div>

      <div>
        <Space>
          {value && (
            <Button onClick={() => setShowCustomerInfo(true)}><SolutionOutlined /></Button>
          )}
          <Button onClick={() => setShowAddCustomer(true)}><UserAddOutlined /></Button>
        </Space>
      </div>
    </div>
  );
};

export default CustomerPickerDesktop;